import BaseService from './BaseService';
import { IComponent } from './FormStructure';

export default class DynamicLDService extends BaseService {
    public async getSandboxDynamicLD(questionId: number): Promise<IComponent[]> {
        const response = await this._get<{ data: IComponent[] }>(`/form/classes/${questionId}/component`);
        return response.data;
    }
}
